import axios from 'axios';

const SESSION_KEY = 'session-guid';

//'https://api-tests.morango4.bitcliq.com/login'

const authProvider = {
  login: ({ username, password }) => {
    return axios.post('https://api-tests.morango4.bitcliq.com/login', { login: username, password })
      .then(({ data }) => {
        if (!data.sessionGuid) {
          return Promise.reject('No sessionGuid returned');
        }
        localStorage.setItem(SESSION_KEY, data.sessionGuid);
        return Promise.resolve();
      })
      .catch(() => {
        return Promise.reject('Invalid credentials');
      });
  },

  logout: () => {
    localStorage.removeItem(SESSION_KEY);
    return Promise.resolve();
  },

  checkAuth: () => {
    return localStorage.getItem(SESSION_KEY)
      ? Promise.resolve()
      : Promise.reject();
  },

  getPermissions: () => Promise.resolve(), // Extend if your API supports permissions

    checkError: (error) => {
    // Optional: if 401 or 403, reject to trigger logout
    const status = error.status || error.response?.status;
    if (status === 401 || status === 403) {
      return Promise.reject();
    }
    return Promise.resolve(); // for other errors, just continue
  },
};

export default authProvider;
